export enum RegistrationType {
    CUSTOMER = 1,
    VENDOR = 2,
}

export const RegistrationTypeName = {
    [RegistrationType.CUSTOMER]: 'Customer',
    [RegistrationType.VENDOR]: 'Vendor',
}

export enum AccountType {
    CUSTOMER = 2,
    VENDOR = 1,
}

export const AccountTypeName = {
    [AccountType.CUSTOMER]: 'Im a Customer',
    [AccountType.VENDOR]: 'Im a Vendor / Partner',
}